import { render, staticRenderFns } from "./EntityDetailDocumentImage.vue?vue&type=template&id=636f747e&scoped=true"
import script from "./EntityDetailDocumentImage.vue?vue&type=script&lang=ts"
export * from "./EntityDetailDocumentImage.vue?vue&type=script&lang=ts"
import style0 from "./EntityDetailDocumentImage.vue?vue&type=style&index=0&id=636f747e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f747e",
  null
  
)

export default component.exports